<template>
  <div class="flex-col items-center space-y-2">
    <div class="flex items-center space-x-2">
      <BaseSearchbox
        class="search-input w-full"
        v-model="searchText"
        placeholder="Search people, companies and roles"
      />
      <div class="flex space-x-0.5">
        <div
          class="external-tab-btn flex h-8 w-24 cursor-pointer items-center justify-center rounded-l p-1 px-3 py-1.5 text-xs"
          :class="selectedTeamTab == 'externalteam' ? 'bg-blue-900 hover:bg-blue-800' : 'bg-gray-800 hover:bg-gray-700'"
          @click="$emit('team-tab-selected', 'externalteam')"
        >
          External
        </div>
        <div
          class="team-tab-btn flex h-8 w-24 cursor-pointer items-center justify-center rounded-r p-1 px-3 py-1.5 text-xs"
          :class="selectedTeamTab == 'team' ? 'bg-blue-900 hover:bg-blue-800' : 'bg-gray-800 hover:bg-gray-700'"
          @click="$emit('team-tab-selected', 'team')"
        >
          Team
        </div>
      </div>
    </div>
    <div
      v-if="selectedTeamTab == 'externalteam'"
      class="external-tab flex flex-col"
      :class="teamMemberCount != undefined ? 'h-97' : 'h-96'"
    >
      <div v-if="selectedTeamTab == 'externalteam'" class="overflow-y-auto">
        <div v-for="company in filteredCompanies" :key="company.name">
          <div
            class="flex w-full items-center space-x-4"
            :class="company.opened ? 'pt-2' : 'border-b border-gray-800 py-2'"
            @click="company.opened = !company.opened"
          >
            <div class="flex w-full cursor-pointer items-center space-x-3 py-1">
              <ChatImage :item="company" size="md"></ChatImage>
              <div>
                <div class="text-sm font-semibold text-gray-100">{{ company.name }}</div>
                <div class="text-xs font-medium text-gray-400">{{ company.category }}</div>
              </div>
            </div>
            <div class="pr-5">
              <ChevronDownIcon
                class="ml-1 h-5 w-5 cursor-pointer text-gray-400 hover:text-white"
                :class="company.opened ? 'rotate-180' : ''"
                @click="$emit('click')"
              ></ChevronDownIcon>
            </div>
          </div>
          <div v-if="company.opened || company.selected" class="pb-3">
            <div class="users_selection mb-3 flex flex-wrap items-center overflow-y-scroll" style="max-height: 5rem">
              <div
                v-for="user in company.users.filter(x => x.selected)"
                :key="user.id"
                class="mr-2 mt-2 flex h-8 flex-wrap items-center space-x-1 rounded bg-gray-800 p-1 px-3 hover:bg-gray-700"
              >
                <span class="text-xs font-medium leading-4">{{ user.name }}</span>
                <XMarkIcon
                  class="h-3 w-3 text-gray-400"
                  @click="
                    selection = selection.filter(u => u.id != user.id);
                    user.selected = false;
                  "
                />
              </div>
            </div>
            <div class="flex-col rounded pr-1">
              <label
                v-for="(user, i) in filteredCompanyUsers(company.users)"
                :key="user.id"
                class="flex cursor-pointer p-4 py-3"
                :class="[
                  user.selected ? 'border-blue-900 bg-blue-900/25' : 'border-gray-700 bg-gray-800/50 hover:bg-gray-800',
                  i === filteredCompanyUsers(company.users).length - 1 ? '' : 'border-b'
                ]"
              >
                <div class="flex w-full items-center justify-between space-x-4">
                  <BaseUser
                    base-class="space-x-4"
                    subtext-class="text-gray-500"
                    :title="user.name"
                    :user="user"
                    :sub-text="user.role_title"
                    :hide-profile="true"
                    :max-text-length="45"
                    :max-title-length="45"
                  >
                    <template #image>
                      <ChatImage :item="user" :show-online="true" size="sm" />
                    </template>
                  </BaseUser>
                  <div class="mr-5">
                    <BaseCheckbox v-model="user.selected" @update:model-value="setSelectedUser(user)"></BaseCheckbox>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedTeamTab == 'team'" class="internal-tab">
      <div class="flex w-full items-center space-x-4 pt-3">
        <div class="flex w-full items-center">
          <div class="flex w-full items-center justify-between">
            <div class="flex items-center space-x-3">
              <ChatImage
                size="md"
                :item="{
                  name: companyInfo ? companyInfo.name : streamUser.team_name,
                  image: companyInfo ? companyInfo.image : null
                }"
              />
              <div>
                <div class="text-sm font-semibold text-gray-100">
                  {{
                    streamUser.companies_data && streamUser.companies_data.length > 0
                      ? streamUser.companies_data.map(c => c.name).join(', ')
                      : streamUser.team_name
                  }}
                </div>
                <div class="text-xs font-medium text-gray-400">
                  {{ streamUser.company_categories ? streamUser.company_categories.join(', ') : '' }}
                </div>
              </div>
            </div>
            <div
              class="group mr-1.5 flex cursor-pointer items-center space-x-1"
              v-if="
                channel &&
                (hasAddPermissions || channel.data.add_member_access) &&
                !channel.data.direct_messaging &&
                teamMemberCount != undefined
              "
              @click="generateShareLink(channel.id)"
            >
              <LinkIcon class="h-4 w-4 text-gray-400 group-hover:text-white" />
              <span class="text-xs text-gray-300 group-hover:text-white">Invite to Chat via Link</span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="pt-3 text-xs font-medium leading-4 text-gray-400">
          ({{ filteredUsers.length }} {{ filteredUsers === 1 ? 'Member' : 'Members' }})
        </div>
        <div class="users_selection mb-3 flex flex-wrap items-center overflow-y-scroll" style="max-height: 5rem">
          <div
            v-for="user in teamUsers.filter(x => x.selected)"
            :key="user.id"
            class="mr-2 mt-2 flex h-8 flex-wrap items-center space-x-1 rounded bg-gray-800 p-1 px-3 hover:bg-gray-700"
          >
            <span class="text-xs font-medium leading-4">{{ user.name }}</span>
            <XMarkIcon
              class="h-3 w-3 text-gray-400"
              @click="
                selection = selection.filter(u => u.id != user.id);
                user.selected = false;
              "
            />
          </div>
        </div>

        <div class="overflow-y-auto rounded" :class="calculatedHeight">
          <div class="flex-col">
            <label
              v-for="(user, i) in filteredUsers"
              class="flex cursor-pointer p-4 py-3"
              :key="user.id"
              :class="[
                user.selected ? 'border-blue-900 bg-blue-900/25' : 'border-gray-700 bg-gray-800/50 hover:bg-gray-800',
                i === filteredUsers.length - 1 ? '' : 'border-b'
              ]"
            >
              <div class="flex w-full items-center justify-between space-x-4">
                <BaseUser
                  base-class="space-x-4"
                  subtext-class="text-gray-500"
                  :title="user.name"
                  :user="user"
                  :sub-text="user.role_title"
                  :hide-profile="true"
                  :max-text-length="45"
                  :max-title-length="45"
                >
                  <template #image>
                    <ChatImage :item="user" :show-online="true" size="sm" />
                  </template>
                </BaseUser>
                <div class="mr-5">
                  <BaseCheckbox v-model="user.selected" @update:model-value="setSelectedUser(user)"></BaseCheckbox>
                </div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import ChatImage from './ChatImage.vue';
import BaseUser from './ChatBaseUser.vue';
import DropdownBase from '@/components/dropdown/DropdownBase.vue';
import { useMapGetter } from '@/store/map-state';
import { LinkIcon, ChevronDownIcon, XMarkIcon, MagnifyingGlassIcon } from '@heroicons/vue/20/solid';
import { getCompaniesByCategory } from '@/composeables/chat';
import { useStore } from 'vuex';
import { generateShareLink } from '@/composeables/chat';
const $store = useStore();
const { streamUser, client } = useMapGetter();
const $emit = defineEmits(['user-selected', 'option-removed', 'team-tab-selected']);
const props = defineProps({
  users: Array,
  teamMemberCount: Number,
  selectedTeamTab: {
    type: String,
    default: 'externalteam'
  },
  searchedTerm: String,
  channel: Object
});

// SELECTED TEAM
const teamSelected = ref(false);

function toggleTeamSelection() {
  teamSelected.value = !teamSelected.value;
  if (teamSelected.value) {
    filteredUsers.value.forEach(user => {
      $emit('user-selected', user);
    });
  } else {
    filteredUsers.value.forEach(user => {
      $emit('option-removed', user);
    });
  }
}

// USERS
const selection = ref([]);
const searchText = ref(props.searchedTerm || '');
const teamUsers = computed(() => {
  return props.users
    .filter(x => x.id != $store.state.session.user.id && (x.teams ? x.team_id === streamUser.value.team_id : false))
    .sort((a, b) => a.name.localeCompare(b.name));
});

const externalUsers = computed(() => {
  return props.users.filter(
    x => x.id != $store.state.session.user.id && x.teams && x.team_id !== streamUser.value.team_id
  );
});

const selectedUsers = computed(() => {
  return props.users.filter(u => u.selected);
});

const selectedTeamUsers = computed(() => {
  return props.users.filter(u => u.selected && u.team_id === streamUser.value.team_id);
});

const filteredUsers = computed(() => {
  return searchText.value !== ''
    ? teamUsers.value.filter(
        x =>
          (x.name && x.name.toLowerCase().includes(searchText.value.toLowerCase())) ||
          (x.companies_data?.length
            ? x.companies_data
                .map(comp => comp.name.toLowerCase())
                .some(x => x.includes(searchText.value.toLowerCase()))
            : false) ||
          (x.role_title ? x.role_title.toLowerCase().includes(searchText.value.toLowerCase()) : false)
      )
    : teamUsers.value;
});

function setSelectedUser(user) {
  if (user.selected == false) {
    selection.value = selection.value.filter(u => u.id !== user.id);
  } else {
    selection.value.push(user);
  }
}

function filteredCompanyUsers(users) {
  return searchText.value.trim().length > 0
    ? users.filter(
        user =>
          user.name.toLowerCase().includes(searchText.value.toLowerCase()) ||
          (user.companies_data?.length
            ? user.companies_data
                .map(comp => comp.name.toLowerCase())
                .some(x => x.includes(searchText.value.toLowerCase()))
            : false) ||
          (user.role_title ? user.role_title.toLowerCase().includes(searchText.value.toLowerCase()) : false)
      )
    : users;
}

// COMPANY
const compananiesLoaded = ref(false);
const selectedCompanies = ref([]);
const companies = ref([]);
const selectedExternalTeamTab = ref('All Companies');

const filteredCompanies = computed(() => {
  return searchText.value !== ''
    ? companies.value.filter(
        comp =>
          comp.users.some(user => user.name.toLowerCase().includes(searchText.value.toLowerCase())) ||
          comp.users.some(user =>
            user.companies_data?.length
              ? user.companies_data
                  .map(comp => comp.name.toLowerCase())
                  .some(x => x.includes(searchText.value.toLowerCase()))
              : false
          ) ||
          comp.users.some(user =>
            user.role_title ? user.role_title.toLowerCase().includes(searchText.value.toLowerCase()) : false
          )
      )
    : companies.value;
});

const companyInfo = computed(() => {
  return streamUser.value.companies_data?.length > 0 ? streamUser.value.companies_data[0] : null;
});

const companyCategories = computed(() => {
  let companyCatogories = $store.state.categories.company;
  let categories = [{ id: 'All Companies', text: 'All Companies' }];
  companyCatogories.forEach(category => {
    categories.push({ id: category.name, text: category.name });
  });
  return categories;
});
watch(
  () => props.users,
  () => {
    if (props.users.length && !compananiesLoaded.value) {
      companies.value = getCompaniesByCategory(
        selectedExternalTeamTab.value,
        externalUsers.value,
        selectedCompanies.value
      );
      companies.value.map(c => {
        if (searchText.value != '' && c.name == searchText.value) {
          c.opened = true;
        }
      });
      compananiesLoaded.value = true;
    }
  },
  { immediate: true, deep: true }
);

function companyAdded(company) {
  company.selected = true;
  selectedCompanies.value.push(company.name);
  company.users.map(x => (x.selected = true));
}
function companyRemoved(company) {
  company.selected = false;
  selectedCompanies.value.splice(company.name, 1);
  company.users.map(x => (x.selected = false));
}

// OTHERS
const calculatedHeight = computed(() => {
  return [
    selectedTeamUsers.value.length > 5
      ? props.teamMemberCount != undefined
        ? 'h-60'
        : 'h-56'
      : selectedTeamUsers.value.length === 0
      ? props.teamMemberCount != undefined
        ? 'h-80'
        : 'h-81'
      : props.teamMemberCount != undefined
      ? 'h-72'
      : 'h-80',
    selectedTeamUsers.value.length > 1 && selectedTeamUsers.value.length != 0 && selectedTeamUsers.value.length <= 5
      ? props.teamMemberCount != undefined
        ? 'h-72'
        : 'h-64'
      : ''
  ];
});

function hasAddPermissions() {
  const channelAdmins = props.channel.data.channel_admins;
  if (channelAdmins && channelAdmins.includes(client.value.user.id) && !props.channel.data.direct_messaging) {
    return true;
  } else {
    return false;
  }
}
</script>
